module.exports = __webpack_public_path__ + "img/kyrgyzstan.6c161d9d.svg";